<ng-template #listTemplate let-visibleAdmins>
  <div
    *ngFor="let admin of visibleAdmins; trackBy: trackById"
    [class.disabled]="disabledIds[admin.id]"
    [class.selected]="selectedIds.has(admin.id)"
    class="result"
  >
    <rt-group (click)="toggleAssignment(admin)" variant="horizontal">
      <span
        [rtTooltipHasTextAlignCenter]="true"
        [rtTooltipMaxWidth]="245"
        [rtTooltip]="disabledIds[admin.id] && lockedAssignmentsTooltip"
      >
        <rt-checkbox
          (click)="toggleAssignment(admin)"
          [checked]="selectedIds.has(admin.id)"
          [disabled]="disabledIds[admin.id]"
          [value]="$any(admin.id)"
        >
        </rt-checkbox>
      </span>
      <rt-avatar
        [imageSrc]="admin.photoThumbUrl"
        [initials]="admin.initials"
        [shape]="'oval'"
        [size]="'base'"
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        context="admin"
      ></rt-avatar>
      <div layout-vertical margin-left-small>
        <rt-heading>
          <rt-truncate> {{ admin.firstName }} {{ admin.lastName }} </rt-truncate>
        </rt-heading>
        <span>{{ inviteModeEnabled ? admin.roleName : admin.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<ng-template #disabledListTemplate let-visibleAdmins>
  <div *ngFor="let admin of visibleAdmins; trackBy: trackById" class="result result__disabled">
    <rt-group
      [rtTooltipMaxWidth]="260"
      [rtTooltip]="'app.candidate.admin_select.no_access.tooltip' | translate"
      rtTooltipPosition="left"
      variant="horizontal"
    >
      <rt-checkbox [disabled]="true" />
      <rt-avatar
        [imageSrc]="admin.photoThumbUrl"
        [initials]="admin.initials"
        [shape]="'oval'"
        [size]="'base'"
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        context="admin"
      ></rt-avatar>
      <div class="admin-info" layout-vertical margin-left-small>
        <span class="heading">{{ admin.firstName }} {{ admin.lastName }}</span>
        <span>{{ admin.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<rt-dialog-header
  [heading]="heading"
  [subheading]="showCountBeforeSubheading ? selectedIds.size + ' ' + subheading : subheading"
  [stepText]="inviteModeEnabled ? ('app.candidate.admin_select.step_1_of_2' | translate) : ''"
>
</rt-dialog-header>

<rt-dialog-body>
  <rt-spinner *ngIf="loadingAdmins"></rt-spinner>

  <div column-layout layout-full-width>
    <rt-box *ngIf="!loadingAdmins" variant="vertical background no-padding">
      <div class="search">
        <rt-form-field>
          <rt-input
            (reset)="cancelSearch()"
            [autoFocus]="true"
            [formControl]="searchControl"
            [hasClearButton]="true"
            [placeholder]="'app.common.placeholders.search.team_members.other' | translate"
            variant="rounded"
          >
            <rt-icon name="search" prefix></rt-icon>
          </rt-input>
        </rt-form-field>

        <rt-group *ngIf="!inviteModeEnabled" class="select-options" variant="horizontal">
          <rt-button (click)="selectAll()" variant="plain">
            {{ 'app.common.all' | translate }}
          </rt-button>
          <rt-button (click)="selectNone()" variant="plain">
            {{ 'app.common.none' | translate }}
          </rt-button>
        </rt-group>
      </div>

      <rt-divider variant="line"></rt-divider>

      <div
        *ngIf="filteredAdmins.length + filteredDisallowedAdmins.length > 20"
        [bufferAmount]="10"
        [executeRefreshOutsideAngularZone]="true"
        [items]="virtualScrollItems"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="0"
        [enableUnequalChildrenSizes]="true"
        (vsUpdate)="onVirtualScrollUpdate($event)"
        class="results results--virtual"
        virtualScroller
      >
        <ng-template
          [ngTemplateOutletContext]="{ $implicit: virtualScrollAdmins }"
          [ngTemplateOutlet]="listTemplate"
        ></ng-template>
        <ng-container *ngIf="blockAccessEnabled && !inviteModeEnabled">
          <div class="header" padding-lr padding-tb-small>
            <rt-heading variant="subheading">
              {{ 'app.candidate.admin_select.no_access.header' | translate | uppercase }}
            </rt-heading>
          </div>
          <ng-template
            [ngTemplateOutlet]="disabledListTemplate"
            [ngTemplateOutletContext]="{ $implicit: virtualScrollDisabledAdmins }"
          ></ng-template>
        </ng-container>
      </div>
      <div *ngIf="filteredAdmins.length + filteredDisallowedAdmins.length <= 20" class="results">
        <ng-template
          [ngTemplateOutletContext]="{ $implicit: filteredAdmins }"
          [ngTemplateOutlet]="listTemplate"
        ></ng-template>
        <ng-container *ngIf="blockAccessEnabled && !inviteModeEnabled">
          <div class="header" padding-lr padding-tb-small>
            <rt-heading variant="subheading">
              {{ 'app.candidate.admin_select.no_access.header' | translate | uppercase }}
            </rt-heading>
          </div>
          <ng-template
            [ngTemplateOutlet]="disabledListTemplate"
            [ngTemplateOutletContext]="{ $implicit: filteredDisallowedAdmins }"
          ></ng-template>
        </ng-container>
      </div>

      <rt-empty-state
        *ngIf="!filteredAdmins.length && !filteredDisallowedAdmins.length"
        [icon]="'search'"
        [title]="'app.common.no_results_found' | translate"
        variant="small"
      >
        <rt-button (click)="cancelSearch()" variant="secondary">
          {{ 'app.assignments.editor.clear_search' | translate }}
        </rt-button>
      </rt-empty-state>
    </rt-box>
  </div>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="cancel()" *ngIf="!loading" variant="plain">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button (click)="submit()" [disabled]="!isValid()" [loading]="loading" variant="primary">
    {{ (inviteModeEnabled ? 'app.common.continue' : 'app.common.save') | translate }}
  </rt-button>
</rt-dialog-footer>
